import { Alert, AlertIcon } from "@chakra-ui/react";

export const CopiedFromOriginalNote = ({ text }: { text: string }) => (
  <Alert status="warning" borderRadius="md" fontSize="sm" py="2" mt="2">
    <AlertIcon />
    {text}
  </Alert>
);
